import { Send } from "lucide-react";

import { useSendUserData } from "@/entities/user/api";
import { Button } from "@/shared/ui/button";
import { DropdownMenuItem } from "@/shared/ui/dropdown-menu";

export const SendUserDataButton = ({
  _id,
  asDropdownChild,
  disabled,
}: {
  _id: string;
  asDropdownChild?: boolean;
  disabled?: boolean;
}) => {
  const { mutateAsync } = useSendUserData({ _id });

  const handleSendUserData = async () => {
    await mutateAsync({ _id });
  };

  if (asDropdownChild) {
    return (
      <DropdownMenuItem
        onClick={handleSendUserData}
        className="flex cursor-pointer gap-3"
        // disabled={isPendingEdit}
      >
        Получить воркера
      </DropdownMenuItem>
    );
  }

  return (
    <Button
      disabled={disabled}
      variant={"outline"}
      className="size-8"
      onClick={handleSendUserData}
    >
      <Send />
    </Button>
  );
};
